import React, { useEffect, useRef, useState } from 'react';
import type { AuditLogItemType } from '@/app/(main)/client-detail/components/tabs/LogsInformation';
import { formatAuditDate } from '@/app/(main)/client-detail/components/tabs/LogsInformation';
import { HighlightedText } from '@/app/components/HighlightedText';
import { Tooltip } from '@/app/components/Tooltip';
import { TooltipWrapper } from '@/app/components/Tooltip/components/TooltipWrapper';
import { AuditTimelineMarker } from '../AuditTimeLineMarker';
import { stripMarkup } from './utils/stripMarkup';

type AuditLogItemProps = AuditLogItemType;

export function AuditLogItem({ title, created_at }: AuditLogItemProps) {
  const description = title;

  const textRef = useRef<HTMLSpanElement>(null);
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    setIsClamped(el.scrollHeight > el.clientHeight);
  }, [description]);

  const plainText = stripMarkup(description);

  return (
    <li className="flex items-start gap-5 min-h-[58px] h-full">
      <AuditTimelineMarker />

      <div className="flex flex-1 flex-col justify-center gap-[6px] min-w-0">
        <Tooltip isVisible={isClamped} content={<TooltipWrapper>{plainText}</TooltipWrapper>} placement="top">
          <span ref={textRef} className="font-inter text-[16px] font-normal leading-6 text-black line-clamp-2">
            <HighlightedText markClassName="font-medium text-[#062060]" boldClassName="font-medium text-[#062060]">
              {description}
            </HighlightedText>
          </span>
        </Tooltip>
        <time className="font-inter text-[14px] font-normal leading-[19.6px] text-grey-700 tabular-nums">
          {formatAuditDate(created_at)}
        </time>
      </div>
    </li>
  );
}
